import React from "react";
import styled from "styled-components";
import { Button, TextView } from "../";
import { colors } from "../../utils";
import { ASSETS } from "../../utils/config";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { openUpgradePopup } from "../../redux/reducers/upgradePopup";

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 24px;
  text-align: center;
  background-color: ${colors.PrimaryPurple100};
  border-radius: 8px;
  margin: 20px 0px;
`;

const Content = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  align-items: center;
  justify-content: center;
`;

const Image = styled.img`
  width: 80px;
  height: 80px;
  margin-bottom: 24px;
  object-fit: contain;
`;

const FeatureEligibility = ({
  requiredSubscription,
  subscription,
  title = `Upgrade to ${subscription} ${requiredSubscription!==3 ? `or higher` : ""} to have access`,
  text="Sorry, your plan does not include this feature. Upgrade your plan now!",
  onUpgradeClick,
  titleVariant="subtitle",
  style,
  // Optional extra style for the Upgrade Now button, so a host screen can
  // give it the same button look as its other buttons (T22.460).
  buttonStyle
}) => {

  const dispatch = useDispatch();

  const handleOnClick = () => {
    if (onUpgradeClick) onUpgradeClick();
    else {
      dispatch(openUpgradePopup({
        requiredSubscription
      }));
    }
  };

  return (
    <Container style={style}>
      <Image src={ASSETS.premiumWheel} alt="Premium Feature" />
      <Content>
        <TextView variant={titleVariant}>{title}</TextView>
        <TextView style={{maxWidth:600}}>
        {text}
        </TextView>
        <Button onClick={handleOnClick} style={{ width: 120, ...buttonStyle }}>
          Upgrade Now
        </Button>
      </Content>
    </Container>
  );
};

export default FeatureEligibility;
